import _isEmpty from 'lodash/isEmpty';
import { Tour } from '@/_models/Tour';
import { getVersion } from '@/components/util';

type Props = {
  tour: Tour;
};

export default function StartScreen({ tour }: Props) {
  if (!tour || _isEmpty(tour?.introScreen)) return null;
  const bgImage = tour?.introScreen?.backgroundImage
    ? `${process.env.REACT_APP_AWS}/tours/${tour.id}/images/${tour.introScreen.backgroundImage}${getVersion(tour.updatedAt)}`
    : `${process.env.REACT_APP_AWS}/tours/${tour.id}/images/${tour.mainImage}${getVersion(tour.updatedAt)}`;
  return (
    <div id="start-screen" className="intro-screen" style={{ backgroundImage: `url(${bgImage})` }}>
      <span className="shadow" />
    </div>
  );
}
